module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Почта Zmail","newServer":"Новая почта","createServer":"Купить почту Zmail","empty":{"title":"На данный момент у вас нет ни одной почты Zmail","text":"Почтовый сервис Z-Mail - это проект компании \\"Зенон Н.С.П.\\" по предоставлению услуг электронной почты пользователям интернета."}}}')
  delete Component.options._Ctor
}
